import { cn } from '@/lib/utils'

import { Header } from './ui/header'

export interface PasswordResetErrorBoundaryFallbackProps {
  message: string
}

export const PasswordResetErrorBoundaryFallback = ({ message }: PasswordResetErrorBoundaryFallbackProps) => {
  return (
    <>
      <Header />
      <div className={cn('flex items-center justify-center', 'w-full')}>
        <p className={cn('text-lg text-slate-800')}>{message}</p>
      </div>
    </>
  )
}
